export const kidsPlanId = 'de7df173-f2e4-49a1-8fe0-bbf9f0f283ff';
